import { createContext } from 'react';

import type { Parameters, Settings } from '../model';
import { DEFAULT_DOMICILE_CODE, settingsDefault } from '../model';
import type { PageToast } from './page_container';

export interface PageContextValue {
  settings: Settings;
  setSettings: (settings: Settings) => void;
  parameters: Parameters;
  domicileCode: string;
  addToast: (toast: PageToast) => void;
}

export const PageContext = createContext<PageContextValue>({
  settings: settingsDefault(),
  setSettings: () => {
    //
  },
  parameters: {
    synced: false,
    status: { level: 'available' },
    domicileCode: DEFAULT_DOMICILE_CODE,
    domiciles: [],
    providers: new Map(),
    fundAssetClasses: new Map(),
    assetClasses: new Map(),
    notices: [],
    license: {
      maxFundsToAnalyze: Infinity,
      maxAssetsToAnalyze: Infinity,
    },
  },
  domicileCode: DEFAULT_DOMICILE_CODE,
  addToast: () => {
    // Empty impl
  },
});
